import { v1 as uuidv1 } from 'uuid';

export const optionsName = (name) => `${name}Options`;
export const optionsMutationName = (name) => `LEVEL4_${name.toUpperCase()}_OPTIONS_SET`;

export const mapFilterOptionsToStore = (filterType) => (
  filterType.reduce((acc, curr) => ({
    ...acc,
    [optionsName(curr.name)]: [],
  }), {})
);

export const mapFilterOptionsToGetters = (filterType) => (
  filterType.reduce((acc, curr) => ({
    ...acc,
    [optionsName(curr.name)]: (state) => state[optionsName(curr.name)],
  }), {})
);

export const mapFilterOptionsToGettersMaps = (filterType) => (
  filterType.reduce((acc, curr) => ({
    ...acc,
    [optionsName(curr.name)]: `level4/${optionsName(curr.name)}`,
  }), {})
);

export const mapFilterOptionsToMutations = (filterType) => (
  filterType.reduce((acc, curr) => ({
    ...acc,
    [optionsMutationName(curr.name)]: (state, newValue) => {
      state[optionsName(curr.name)] = newValue;
    },
  }), {})
);

export const mapOptions = (options) => options.map((option) => ({
  ...option,
  name: option.name || option.id || option.value || option.produktart || option.katalogumfang,
  value: option.value || option.id || option.name || option.produktart || option.katalogumfang,
  id: options.Id || option.value || option.name || options.produktart || option.katalogumfang,
  uuid: uuidv1(),
}));
